import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',

    className: null,
};

function Waves({ color, className }) {
    return (
        <svg
            width="119"
            height="29"
            viewBox="0 0 119 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <g clipPath="url(#clip0_2712_2287)">
                <path d="M74.7963 5.31934H72.4651V23.9533H74.7963V5.31934Z" fill={color} />
                <path d="M79.17 8.1543H76.8387V21.1171H79.17V8.1543Z" fill={color} />
                <path d="M83.5437 11.3789H81.2125V17.8938H83.5437V11.3789Z" fill={color} />
                <path d="M70.4244 8.1543H68.0931V21.1171H70.4244V8.1543Z" fill={color} />
                <path d="M87.9174 9.8457H85.5861V19.4268H87.9174V9.8457Z" fill={color} />
                <path d="M66.0507 10.8037H63.7194V18.4686H66.0507V10.8037Z" fill={color} />
                <path d="M92.2911 7.59082H89.9598V21.6816H92.2911V7.59082Z" fill={color} />
                <path d="M96.663 4.39746H94.3317V24.8748H96.663V4.39746Z" fill={color} />
                <path d="M101.037 0.87207H98.7054V28.3995H101.037V0.87207Z" fill={color} />
                <path d="M105.41 4.39746H103.079V24.8748H105.41V4.39746Z" fill={color} />
                <path d="M109.784 8.00488H107.453V21.267H109.784V8.00488Z" fill={color} />
                <path d="M114.158 11.0283H111.826V18.2424H114.158V11.0283Z" fill={color} />
                <path d="M118.53 12.8555H116.198V16.4151H118.53V12.8555Z" fill={color} />
                <path d="M59.3458 16.416H61.677V12.8563H59.3458V16.416Z" fill={color} />
            </g>
            <g clipPath="url(#clip1_2712_2287)">
                <path d="M15.6124 5.31934H13.2812V23.9533H15.6124V5.31934Z" fill={color} />
                <path d="M19.9861 8.1543H17.6548V21.1171H19.9861V8.1543Z" fill={color} />
                <path d="M24.3598 11.3789H22.0286V17.8938H24.3598V11.3789Z" fill={color} />
                <path d="M11.2405 8.1543H8.90924V21.1171H11.2405V8.1543Z" fill={color} />
                <path d="M28.7335 9.8457H26.4022V19.4268H28.7335V9.8457Z" fill={color} />
                <path d="M6.86679 10.8037H4.53555V18.4686H6.86679V10.8037Z" fill={color} />
                <path d="M33.1072 7.59082H30.7759V21.6816H33.1072V7.59082Z" fill={color} />
                <path d="M37.4791 4.39746H35.1478V24.8748H37.4791V4.39746Z" fill={color} />
                <path d="M41.8528 0.87207H39.5215V28.3995H41.8528V0.87207Z" fill={color} />
                <path d="M46.2264 4.39746H43.8952V24.8748H46.2264V4.39746Z" fill={color} />
                <path d="M50.6002 8.00488H48.2689V21.267H50.6002V8.00488Z" fill={color} />
                <path d="M54.9738 11.0283H52.6426V18.2424H54.9738V11.0283Z" fill={color} />
                <path d="M59.3458 12.8555H57.0145V16.4151H59.3458V12.8555Z" fill={color} />
                <path
                    d="M0.161864 16.416H2.4931L2.4931 12.8563H0.161864L0.161864 16.416Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_2712_2287">
                    <rect
                        width="59.1839"
                        height="27.5274"
                        fill="white"
                        transform="translate(59.3458 0.87207)"
                    />
                </clipPath>
                <clipPath id="clip1_2712_2287">
                    <rect
                        width="59.1839"
                        height="27.5274"
                        fill="white"
                        transform="translate(0.161865 0.87207)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

Waves.propTypes = propTypes;
Waves.defaultProps = defaultProps;

export default Waves;
